import { Text } from 'react-native-paper';
import useFormStyle from '@/components/Styles/useFormStyle';
import { Redirect, useRouter } from 'expo-router';
import ScreenMargin from '@/components/ScreenMargin';
import { useForm } from 'react-hook-form';
import {
  InsertPatientMutationVariables,
  useInsertLaboratoireMutation,
  useInsertPatientMutation,
} from '@/data/data';
import { useUserContext } from '@/components/Auth/UserContext';
import { useState } from 'react';
import Form from '@/components/Form/Form';
import { View } from 'react-native';
import FTextInput from '@/components/Form/TextInput';
import BaseContainer from '@/components/BaseContainer';
import { AvailableValidationRules } from '@/components/Form/validation';
import FormSectionFooter from '@/components/Form/FormSectionFooter';
import { useApolloClient } from '@apollo/client';
import { getAdminLink, getNormalLink } from '@/components/Apollo/client';
import { useAuthContext } from '@/components/Auth/AuthContext';
import {useTranslation} from "react-i18next";

const AjouterLaboratoirePage = () => {
  const client = useApolloClient();
  const { user } = useUserContext();
  const router = useRouter();
  const authUser = useAuthContext();
  const [loading, setLoading] = useState(false);

  const [insertLaboratoire] = useInsertLaboratoireMutation();
  const form = useForm<InsertPatientMutationVariables>();
  const styles = useFormStyle();
  const { t } = useTranslation();


  if (authUser.payload && authUser.payload['cognito:groups'].indexOf('admin') <= -1) {
    return <Redirect href={'/patients'} />;
  }

  return (
    <ScreenMargin>
      <BaseContainer withScrollView={'keyboardAware'}>
        <Text style={styles?.headerForm}>{t('Ajouter un laboratoire')}</Text>

        <Form<InsertPatientMutationVariables> {...form}>
          <View style={styles?.bodyForm}>
            <View style={styles?.groupForm}>
              <Text style={styles?.titleGroupForm}>{t('Données')}</Text>
              <FTextInput
                name={'nom'}
                label={'Nom'}
                withMargin={false}
                containerStyle={styles.input2Col}
                validators={[AvailableValidationRules.required]}
              />
            </View>
          </View>
          <View style={styles?.footerForm}>
            <FormSectionFooter
              saveLoading={loading}
              saveDisabled={loading}
              onPress={form.handleSubmit(async (data) => {
                setLoading(true);
                if (user) {
                  client.setLink(getAdminLink());
                  await insertLaboratoire({
                    variables: {
                      ...data,
                    },
                    fetchPolicy: 'network-only',
                  });
                  client.setLink(getNormalLink());
                }
                setLoading(false);
                router.back();
              })}
            />
          </View>
        </Form>
      </BaseContainer>
    </ScreenMargin>
  );
};

export default AjouterLaboratoirePage;
